<div *ngIf="!inView"
     class="st-topic-item-content-container"></div>
<div *ngIf="inView"
     class="st-topic-item-border-left"
     leftBorder
     [record]="data">
</div>
<ng-template [ngIf]="showwFullCard"
             [ngIfElse]="mobileCard">
    <div *ngIf="inView"
         class="st-topic-item-content-container"
         [class.st-topic-item-content-container__mouse-entered]="mouseEntered"
         (mouseenter)="onMouseEnter()"
         (mouseleave)="onMouseLeave()">
        <div class="st-topic-item-content-container__static">
            <div class="st-topic-item-content-container-main">
                <div class="st-topic-item-content-container-main-top-row">
                    <topic-type class="st-topic-item-content-container-main__type"
                                [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicType)"
                                [labelTranslationPrefix]="topicTypeTranslationLabelPrefix"
                                showAdd
                                [maxValuesToShow]="maxTypesToShow"
                                [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicType]"
                                [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicType]?.DefaultCaption"
                                (changed)="updateTopic($event, pstFieldNames.PSTTopicType)"
                                [value]="data?.topicType"></topic-type>
                    <span class="st-topic-item-content-container-main__time-updated">{{timeUpdatedLabel}}</span>
                    <span class="st-topic-item-content-container-main__updated-by">{{updatedBy}}</span>
                </div>
                <st-text-area-overlay class="st-topic-item-content-container-main__slug"
                                      minRows="1"
                                      minHeight="1.75rem"
                                      [value]="data?.topicSlug"
                                      [disabled]="cardDisabled"
                                      maxLength="50"
                                      disableNewLine
                                      [textToHighlight]="searchString"
                                      (changed)="updateTopic($event, pstFieldNames.PSTTopicSlug)"
                                      panelClass="st-topic-item-content-container-main__slug"
                                      [placeholder]="languageSettings.PSTWebSlugPlaceholder"></st-text-area-overlay>
                <st-text-area-overlay class="st-topic-item-content-container-main__summary"
                                      [value]="data?.summary"
                                      [disabled]="cardDisabled"
                                      [required]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicSummary]?.Required"
                                      minRows="3"
                                      [textToHighlight]="searchString"
                                      minHeight="3rem"
                                      panelClass="st-topic-item-content-container-main__summary"
                                      (changed)="updateTopic($event, pstFieldNames.PSTTopicSummary)"
                                      [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicSummary]?.DefaultCaption"></st-text-area-overlay>
                <tags-autocomplete [value]="data?.tags"
                                   [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicTag]"
                                   (changed)="updateTopic($event, pstFieldNames.PSTTopicTag)"
                                   [maxItemsToShow]="maxTagsToShow"
                                   [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicTag]?.Required"
                                   [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicTag]?.DefaultCaption">
                </tags-autocomplete>
            </div>
            <div class="st-topic-item-content-container-assigns">
                <desk class="st-topic-item-content-container-assigns__desk"
                      [value]="data?.department"
                      [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicDepartment]"
                      [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicDepartment]?.Required"
                      (changed)="updateTopic($event, pstFieldNames.PSTTopicDepartment)"
                      [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicDepartment]?.DefaultCaption"
                      [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicDepartment]?.DefaultCaption"
                      [itemList]="globalTablesService.getListItemsForDesk(data?.type)">
                </desk>
                <staff-id-list [value]="data?.storyOwner"
                               [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicStoryOwner]"
                               [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.Required"
                               (changed)="updateTopic($event, pstFieldNames.PSTTopicStoryOwner)"
                               [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.DefaultCaption"
                               class="st-topic-item-content-container-assigns__owners"></staff-id-list>
                <div class="st-topic-item-content-container-assigns__assignments">
                    <div class="st-topic-item-content-container-assigns__assignments-icons"
                         #triggerAssignmentOverlay="cdkOverlayOrigin"
                         cdkOverlayOrigin
                         (mouseleave)="onMouseOutAssignments($event)"
                         (mouseenter)="openAssignmentsOverlay()">
                        <icon *ngIf="data?.children[0]"
                              hasBorder
                              [attr.disabled]="cardDisabled"
                              [type]="data?.children[0]?.coverageType"
                              (click)="onAssignmentOpen.emit(data?.children[0])"
                              [record]="data?.children[0]"></icon>
                        <icon *ngIf="data?.children[1]"
                              hasBorder
                              [attr.disabled]="cardDisabled"
                              [type]="data?.children[1]?.coverageType"
                              (click)="onAssignmentOpen.emit(data?.children[1])"
                              [record]="data?.children[1]"></icon>
                        <icon *ngIf="data?.children[2]"
                              hasBorder
                              [attr.disabled]="cardDisabled"
                              [type]="data?.children[2]?.coverageType"
                              (click)="onAssignmentOpen.emit(data?.children[2])"
                              [record]="data?.children[2]"></icon>
                        <icon *ngIf="data?.children[3]"
                              hasBorder
                              [attr.disabled]="cardDisabled"
                              [type]="data?.children[3]?.coverageType"
                              (click)="onAssignmentOpen.emit(data?.children[3])"
                              [record]="data?.children[3]"></icon>
                        <button mat-icon-button
                                class="st-topic-item-content-container-assigns__assignments-extraCount"
                                *ngIf="shouldShowExtraAssignments; else noExtraAssignments">
                            +{{extraAssignmentsCount}}
                        </button>
                        <ng-template #noExtraAssignments>
                            <icon *ngIf="data?.children[4]"
                                  hasBorder
                                  [attr.disabled]="cardDisabled"
                                  [type]="data?.children[4]?.coverageType"
                                  (click)="onAssignmentOpen.emit(data?.children[4])"
                                  [record]="data?.children[4]"></icon>
                        </ng-template>

                        <mat-menu #assignmentsMenu="matMenu">
                            <mat-selection-list hideSingleSelectionIndicator
                                                [multiple]="false">
                                <mat-list-option *ngFor="let item of assignmentTypes"
                                                 [dir]="isRTL"
                                                 (click)="createAssignment(item.id)"
                                                 [value]="item.id">
                                    <icon matListItemIcon
                                          [type]="item.id"></icon>
                                    <div matListItemTitle>{{item.title}}</div>
                                </mat-list-option>
                            </mat-selection-list>
                        </mat-menu>

                        <ng-template #assignmentsOverlay>
                            <ng-template #assignmentsOverlayEl
                                         cdkConnectedOverlay
                                         [cdkConnectedOverlayOrigin]="triggerAssignmentOverlay"
                                         [cdkConnectedOverlayOpen]="isAssignmentsPanelOpen"
                                         (attach)="assignmentsPanelAttached()">
                                <assignments-overlay [data]="data"
                                                     [editable]="topicEditable"
                                                     [isPanelOpen]="isAssignmentsPanelOpen"
                                                     [onObjectOpen]="onAssignmentOpen">
                                </assignments-overlay>
                            </ng-template>
                        </ng-template>
                    </div>
                    <button mat-button
                            [disabled]="cardDisabled"
                            class="st-topic-item-content-container-assigns__add-assignment-button"
                            [matMenuTriggerFor]="assignmentsMenu">
                        <mat-icon>
                            add
                        </mat-icon>
                        {{languageSettings.PSTWebAssignmentAddLabel}}
                    </button>
                </div>
            </div>
            <div class="st-topic-item-content-container-meta">
                <date-time-picker class="st-topic-item-content-container-meta__date-picker"
                                  [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicFileDate]"
                                  asCustomField
                                  *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.Validation?.toUpperCase() == FieldDefValidations.TIME; else datePicker"
                                  [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.Required"
                                  [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.DefaultCaption"
                                  (changed)="updateTopic($event, pstFieldNames.PSTTopicFileDate)"
                                  [value]="getDateTimeValue(pstFieldNames.PSTTopicFileDate)">
                </date-time-picker>
                <ng-template #datePicker>
                    <date-picker class="st-topic-item-content-container-meta__date-picker"
                                 [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.Required"
                                 [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicFileDate]?.DefaultCaption"
                                 (changed)="updateTopic($event, pstFieldNames.PSTTopicFileDate)"
                                 [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicFileDate]"
                                 [value]="getDateTimeValue(pstFieldNames.PSTTopicFileDate)"></date-picker>
                </ng-template>
                <status class="st-topic-item-content-container-meta__status"
                        [value]="data.status"
                        [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicStatus]"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.Required"
                        (changed)="updateTopic($event, pstFieldNames.PSTTopicStatus)"
                        [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                        [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicStatus)"></status>
            </div>
            <div class="st-topic-item-content-container-actions">
                <div *ngIf="!isPublication">
                    <button class="st-topic-item-content-container-actions__external"
                            mat-icon-button
                            #trigger="cdkOverlayOrigin"
                            cdkOverlayOrigin
                            [disabled]="cardDisabled || preview"
                            (click)="isExternalActionPanelOpen = true">
                        <mat-icon>more_horiz</mat-icon></button>
                    <ng-template #externalActions>
                        <ng-template #externalActionsEl
                                     cdkConnectedOverlay
                                     [cdkConnectedOverlayOrigin]="trigger"
                                     [cdkConnectedOverlayOpen]="isExternalActionPanelOpen"
                                     (overlayOutsideClick)="isExternalActionPanelOpen = false">
                            <external-actions-overlay [data]="data"
                                                      [editable]="topicEditable"
                                                      [isPanelOpen]="isExternalActionPanelOpen"
                                                      [onObjectOpen]="onTopicOpen"
                                                      (onActionClick)="isExternalActionPanelOpen = false">
                            </external-actions-overlay>
                        </ng-template>
                    </ng-template>
                </div>
                <button mat-icon-button
                        *ngIf="isPublication"
                        [disabled]="isReadOnly || cardDisabled"
                        class="st-assignment-item-content-container-actions__delete"
                        (click)="deletePublication($event)">
                    <mat-icon>delete_outline</mat-icon>
                </button>
                <button class="st-topic-item-content-container-actions__fullscreen"
                        (click)="onTopicOpen.emit()"
                        [matTooltip]="languageSettings.PSTWebOpenFullScreenText"
                        [disabled]="preview"
                        mat-icon-button>
                    <mat-icon>fullscreen</mat-icon>
                </button>
                <button class="st-topic-item-content-container-actions__approve"
                        [disabled]="cardDisabled  || data.readOnlyCriteria[pstFieldNames?.PSTApproved]"
                        *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.TopicProp && !cardDisabled"
                        [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                        (click)="updateTopic(!data.pstApproved, pstFieldNames.PSTApproved)"
                        [class.st-topic-item-content-container-actions__approve--active]="data.pstApproved"
                        mat-icon-button>
                    <mat-icon>done</mat-icon>
                </button>
            </div>
        </div>
        <ng-template [ngIf]="customCardItems?.length> 0">
            <div class="st-topic-item-container-dynamic-controls">
                <ng-template ngFor
                             let-idx
                             [ngForOf]="[0, 1, 2, 3]">
                    <div class="st-topic-item-container-dynamic-controls-item">
                        <ng-container *ngIf="customCardItems[idx]"
                                      [ngTemplateOutlet]="customField"
                                      [ngTemplateOutletContext]="{ item: customCardItems[idx], data: data, validation: customCardItems[idx].Validation.toUpperCase() }">
                        </ng-container>
                    </div>
                </ng-template>
            </div>
        </ng-template>
    </div>

    <ng-template #customField
                 let-item="item"
                 let-data="data"
                 let-validation="validation">
        <ng-container [ngSwitch]="validation">
            <ng-template [ngSwitchCase]="FieldDefValidations.LOOKUPLIST">
                <tags-autocomplete [value]="data.get(item.ID)"
                                   [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                                   asCustomField
                                   (changed)="updateTopic($event, item.ID)"
                                   [label]="item.DefaultCaption">
                </tags-autocomplete>
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.TEXT">
                <ng-template [ngIf]="!item.WordWrap">
                    <text-field class="st-topic-item-container-dynamic-controls-item__text-input"
                                [placeholder]="item.DefaultCaption"
                                [label]="item.DefaultCaption"
                                [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                                showLinks
                                [textToHighlight]="searchString"
                                [value]="data.get(item.ID)"
                                (changed)="updateTopic($event, item.ID)">
                    </text-field>
                </ng-template>

                <ng-template [ngIf]="item.WordWrap">
                    <st-text-area-overlay class="st-topic-item-container-dynamic-controls-item__text-area"
                                          minRows="1"
                                          [textToHighlight]="searchString"
                                          minHeight="2.5rem"
                                          [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                                          [class.st-topic-item-container-dynamic-controls-item__text-area--preview]="preview"
                                          [value]="data?.get(item.ID)"
                                          (changed)="updateTopic($event, item.ID)"
                                          [placeholder]="item.DefaultCaption">
                    </st-text-area-overlay>
                </ng-template>
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.COMBOBOX">
                <!-- TODO NOT WORKING  -->
                <combo-box [placeholder]="item.DefaultCaption"
                           [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                           [value]="data?.get(item.ID)"
                           [addEmptyOption]="!item.Required"
                           (changed)="updateTopic($event, item.ID)"
                           [itemList]="globalTablesService.getListItems(item.ID, item.List)"
                           [label]="item.DefaultCaption">
                </combo-box>
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.CHECKLIST">
                <!-- FIX THIS FOR DESK LABEL -->
                <check-list [value]="data?.get(item.ID)"
                            asCustomField
                            [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                            (changed)="updateTopic($event, item.ID)"
                            [itemList]="globalTablesService.getListItems(item.ID, item.List)"
                            [label]="item.DefaultCaption">
                </check-list>
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.CHECKBOX">
                <!-- TODO PROPER FILTER CHECKBOX VALUES ?  -->
                <check-box [label]="item.DefaultCaption"
                           (changed)="updateTopic($event, item.ID)"
                           [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                           [value]="data?.get(item.ID)"
                           [label]="item.DefaultCaption">
                </check-box>
            </ng-template>
            <ng-template [ngSwitchCase]="FieldDefValidations.STAFFIDLIST">
                <staff-id-list-multiple [value]="data?.get(item.ID)"
                                        [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                                        [required]="item?.Required"
                                        asCustomField
                                        (changed)="updateTopic($event, item.ID)"
                                        [label]="item.DefaultCaption">
                </staff-id-list-multiple>
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.TREE">
                <tree [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                      [required]="enforceRequiredFieldsOnCreate && item.Required"
                      (changed)="updateTopic($event, item.ID)"
                      [value]="data.get(item.ID)"
                      [label]="item.DefaultCaption"
                      [itemList]="globalTablesService.getlistItemsForTree(item.List)">
                </tree>
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.ADDRESS">
                <ng-template [ngIf]="item.ComplexPropInnerId">
                    <text-field [placeholder]="item.DefaultCaption"
                                [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                                floating
                                [textToHighlight]="searchString"
                                [value]="getInnerProp(item)"
                                (changed)="updateTopicAddresSubField($event , item, item.ComplexPropInnerId)">
                    </text-field>
                </ng-template>
                <!-- [value]="globalTablesService.getAddressPropertiesFor(item.ID)" -->
                <ng-template [ngIf]="!item.ComplexPropInnerId">
                    <address-form [width]="'100%'"
                                  [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                                  [placeholder]="item.DefaultCaption"
                                  [value]="data.get(item.ID)"
                                  (changed)="updateTopic($event , item.ID)"></address-form>
                </ng-template>
            </ng-template>
            <ng-template [ngSwitchCase]="FieldDefValidations.DATETIMERANGE">
                <date-time-range [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                                 [required]="enforceRequiredFieldsOnCreate && item.Required"
                                 [label]="item.DefaultCaption"
                                 (changed)="updateTopic($event, item.ID)"
                                 [value]="getDateRangeValue(item.ID)"></date-time-range>
            </ng-template>
            <ng-template [ngSwitchCase]="FieldDefValidations.DATE">
                <date-picker [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                             asCustomField
                             [min]="getMinDate(item.ID)"
                             [required]="enforceRequiredFieldsOnCreate && item.Required"
                             [label]="item.DefaultCaption"
                             (changed)="updateTopic($event, item.ID)"
                             [value]="getDateTimeValue(item.ID)">
                </date-picker>
            </ng-template>
            <ng-template ngSwitchDefault>
                <date-time-picker [disabled]="cardDisabled || item.ReadOnlyValue || data.readOnlyCriteria[item.ID]"
                                  asCustomField
                                  [min]="getMinDate(item.ID)"
                                  *ngIf="(item.Validation.toUpperCase() == 'TIME' ||
                                                        item.Validation.toUpperCase() == 'MOSDATETIME')"
                                  [required]="enforceRequiredFieldsOnCreate && item.Required"
                                  [label]="item.DefaultCaption"
                                  (changed)="updateTopic($event, item.ID)"
                                  [value]="getDateTimeValue(item.ID)">
                </date-time-picker>
            </ng-template>
        </ng-container>
    </ng-template>
</ng-template>

<ng-template #mobileCard>
    <div *ngIf="inView"
         class="st-topic-item-content-container__mobile">
        <div class="st-topic-item-content-container__mobile--top-row">
            <div class="st-topic-item-content-container__mobile--topic-type-container">
                <div *ngFor="let type of data?.topicType"
                     class="st-topic-item-content-container__mobile--topic-type"
                     topicCardTypeColor
                     [itemType]="type"
                     [record]="data">
                </div>
            </div>
            <div class="st-topic-item-content-container__mobile--status">
                {{data.status || globalTablesService.FieldDefsDict[pstFieldNames.PSTTopicStatus]?.DefaultCaption}}
            </div>
        </div>
        <div class="st-topic-item-content-container__mobile--slug">
            {{data.topicSlug}}
        </div>

        <div class="st-topic-item-content-container__mobile--desk">
            <mat-icon class="st-topic-item-content-container__mobile--owner__icon">
                business
            </mat-icon>
            <span
                  class="st-topic-item-content-container__mobile--owner__text">{{getItemString(pstFieldNames.PSTTopicDepartment)}}</span>
        </div>

        <div class="st-topic-item-content-container__mobile--owner">
            <mat-icon class="st-topic-item-content-container__mobile--owner__icon">
                people
            </mat-icon>
            <span
                  class="st-topic-item-content-container__mobile--owner__text">{{getItemString(pstFieldNames.PSTTopicStoryOwner)}}</span>
        </div>

        <div class="st-topic-item-content-container__mobile--assignments">
            <mat-icon class="st-topic-item-content-container__mobile--assignments__icon">
                task
            </mat-icon>
            <div class="st-topic-item-content-container__mobile--assignments__items">
                <icon *ngIf="data?.children[0]"
                      hasBorder
                      medium="true"
                      (click)="onAssignmentOpen.emit(data?.children[0])"
                      [type]="data?.children[0]?.coverageType"
                      [record]="data?.children[0]"></icon>
                <icon *ngIf="data?.children[1]"
                      hasBorder
                      medium="true"
                      (click)="onAssignmentOpen.emit(data?.children[1])"
                      [type]="data?.children[1]?.coverageType"
                      [record]="data?.children[1]"></icon>
                <icon *ngIf="data?.children[2]"
                      hasBorder
                      medium="true"
                      (click)="onAssignmentOpen.emit(data?.children[2])"
                      [type]="data?.children[2]?.coverageType"
                      [record]="data?.children[2]"></icon>
                <icon *ngIf="data?.children[3]"
                      hasBorder
                      medium="true"
                      (click)="onAssignmentOpen.emit(data?.children[3])"
                      [type]="data?.children[3]?.coverageType"
                      [record]="data?.children[3]"></icon>
                <button mat-icon-button
                        class="st-topic-item-content-container__mobile--assignments__items--extra"
                        *ngIf="shouldShowExtraAssignments; else noExtraAssignments">
                    +{{extraAssignmentsCount}}
                </button>
                <ng-template #noExtraAssignments>
                    <icon *ngIf="data?.children[4]"
                          hasBorder
                          medium="true"
                          (click)="onAssignmentOpen.emit(data?.children[4])"
                          [type]="data?.children[4]?.coverageType"
                          [record]="data?.children[4]"></icon>
                </ng-template>
            </div>
        </div>
    </div>
</ng-template>
